/**
 * Custom cursor: dot with multiply blend trails the cursor; on any anchor hover
 * transforms to the cursor icon (78px). Only runs when (pointer: fine) for desktop.
 */

const LERP = 0.12;

function getAnchorUnder(el) {
	if (!el || !el.closest) return null;
	return el.closest("a[href]");
}

function isExcludedLink(el) {
	const a = getAnchorUnder(el);
	if (!a || a.getAttribute("href") === "") return false;
	if (a.classList.contains("ui-btn") || a.classList.contains("social-icon") || a.classList.contains("header__logo")) return true;
	if (a.closest(".header__nav")) return true;
	return false;
}

function isAnchorLink(el) {
	const a = getAnchorUnder(el);
	if (!a || a.getAttribute("href") === "" || a.getAttribute("href") === "#") return false;
	if (a.classList.contains("ui-btn") || a.classList.contains("social-icon")) return false;
	if (a.closest(".header__nav")) return false;
	return true;
}


function isButton(el) {
	return el && el.closest && el.closest("button");
}

function initCustomCursor() {
	if (!window.matchMedia || !window.matchMedia("(pointer: fine)").matches) return;

	const themeUri = typeof glaceTheme !== "undefined" && glaceTheme.themeUri ? glaceTheme.themeUri : "";
	const iconUrl = themeUri ? `${themeUri}/library/images/icons/cursor.svg` : "";
	const dragIconUrl = themeUri ? `${themeUri}/library/images/icons/cursor-drag.svg?v=2` : "";

	const wrap = document.createElement("div");
	wrap.className = "custom-cursor";
	wrap.setAttribute("aria-hidden", "true");

	const dot = document.createElement("div");
	dot.className = "custom-cursor__dot";

	const icon = document.createElement("div");
	icon.className = "custom-cursor__icon";
	if (iconUrl) icon.style.backgroundImage = `url(${iconUrl})`;

	const iconDrag = document.createElement("div");
	iconDrag.className = "custom-cursor__icon-drag";
	if (dragIconUrl) iconDrag.style.backgroundImage = `url(${dragIconUrl})`;

	wrap.appendChild(dot);
	wrap.appendChild(icon);
	wrap.appendChild(iconDrag);
	document.body.appendChild(wrap);

	let mouseX = 0;
	let mouseY = 0;
	let x = 0;
	let y = 0;
	let rafId = null;

	function lerp(a, b, t) {
		return a + (b - a) * t;
	}

	function updatePosition() {
		x = lerp(x, mouseX, LERP);
		y = lerp(y, mouseY, LERP);
		wrap.style.transform = `translate3d(${x}px, ${y}px, 0)`;
		rafId = requestAnimationFrame(updatePosition);
	}

	function onMouseMove(e) {
		mouseX = e.clientX;
		mouseY = e.clientY;
		if (rafId === null) rafId = requestAnimationFrame(updatePosition);
	}

	function setLinkHover(hover) {
		wrap.classList.toggle("custom-cursor--link-hover", hover);
	}

	function setDragHover(hover) {
		wrap.classList.toggle("custom-cursor--drag-hover", hover);
	}

	function setHidden(hidden) {
		wrap.classList.toggle("custom-cursor--hidden", hidden);
	}

	function onMouseOver(e) {
		if (isExcludedLink(e.target) || isButton(e.target)) {
			setLinkHover(false);
			setDragHover(false);
			setHidden(true);
		} else {
			setHidden(false);
			if (isSliderWrap(e.target)) {
				setDragHover(true);
				setLinkHover(false);
			} else {
				setDragHover(false);
				setLinkHover(isAnchorLink(e.target));
			}
		}
	}

	function onMouseOut(e) {
		if (!isExcludedLink(e.relatedTarget) && !isButton(e.relatedTarget)) setHidden(false);
		if (!isAnchorLink(e.relatedTarget)) setLinkHover(false);
		if (!isSliderWrap(e.relatedTarget)) setDragHover(false);
	}

	document.addEventListener("mousemove", onMouseMove, { passive: true });
	document.addEventListener("mouseover", onMouseOver, { passive: true });
	document.addEventListener("mouseout", onMouseOut, { passive: true });
}

export function initCustomCursorModule() {
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initCustomCursor);
	} else {
		initCustomCursor();
	}
}
